import {
  Avatar,
  Box,
  ButtonBase,
  Card,
  CardContent,
  Chip,
  Grid2,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ServiceTypeConfigInputChip from "./ServiceTypeConfigInputChip";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const ServiceTypeConfigAccordionCard = ({
  service,
  onChangeService,
  value,
  deleteIdsHandler,
  defaultShow = true,
}) => {
  console.log(value, 111);
  const [show, setShow] = useState(true);
  useEffect(() => {
    setShow(defaultShow);
  }, [defaultShow]);

  let prefLabel =
    service.printPreference === true
      ? "Per Service"
      : service.printPreference === false
        ? "Per Page"
        : "Not Set";

  return (
    <Card
      component={Paper}
      elevation={2}
      sx={{
        borderRadius: 4,
        "& .MuiCardContent-root": {
          paddingBottom: "0!important",
        },
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <ButtonBase
          sx={{ borderRadius: 4, width: "100%", px: 4, py: 2 }}
          onClick={() => setShow(!show)}
        >
          <Box
            display="flex"
            width={"100%"}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center" width={"100%"} gap={1}>
              <Typography variant="h5">{service.name}</Typography>
              <Chip
                label={prefLabel}
                size="small"
                color="default"
              />

              {service.isRequired && (
                <Chip
                  label="Required"
                  size="small"
                  color="primary"
                />
              )}

              {service.isDefault && (
                <Chip
                  label="Default"
                  size="small"
                  color="primary"
                  variant="filled"
                />
              )}

              {!show && <SelectedServiceChipList types={value?.types} />}
              <IconButton
                sx={{ marginLeft: "auto" }}
                onClick={(e) => {
                  setShow(!show);
                  e.stopPropagation();
                }}
              >
                {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            </Box>
          </Box>
        </ButtonBase>

        {show && (
          <Box
            sx={{
              px: 4,
              py: 2,
            }}
          >
            <Typography variant="subtitle2" mb={2} color="text.secondary">
              {service.description || "No description provided."}
            </Typography>
            <Grid2 container spacing={2}>
              {service.types.length > 0 ? (
                service.types.map((type) => (
                  <ServiceTypeConfigInputChip
                    value={value?.types?.find?.((t) => t.id === type.id)}
                    onChange={onChangeService}
                    key={type.id}
                    type={type}
                    service={service}
                    deleteIdsHandler={deleteIdsHandler}
                    isDefault={service.isDefault}
                  />
                ))
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ pl: 2 }}
                >
                  No service types available.
                </Typography>
              )}
            </Grid2>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ServiceTypeConfigAccordionCard;

const SelectedServiceChipList = ({ types }) => {
  if (!types || types.length === 0) return null;
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
        px: 2,
      }}
    >
      {types.map((type) => (
        <Chip
          key={type.id}
          avatar={<Avatar alt={type.name} src={type.icon} />}
          label={`${type.name} |  ${Number(type.value) !== 0 ? `₹${type.value}` : "FREE"}`}
          variant="outlined"
        />
      ))}
    </Box>
  );
};
